import { ajaxPostJson, setParams } from './ajax';
//统计入库审核记录条数
export const numberEntryRecords = (params) => {
  return ajaxPostJson(`/record/foreground/countRecords`, params,);
};
//分页查询入库审核记录
export const recordQueryPage = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/record/foreground/queryPage`, params,);
};
//删除语料库
export const deleteLanguageDatabase = (params) => {
  return ajaxPostJson(`/record/foreground/deleteTransCorpusLib`, params,);
};
//一键入库
export const akeyTreasury = (params) => {
  return ajaxPostJson(`/record/foreground/corpusSentPutInStorage`, params,);
};







/* 详情页接口 */

//分页查看入库审核详情
export const queryPageDetails = (params) => {
  // params.filter = setParams(params.filter);
  return ajaxPostJson(`/record/foreground/queryDetails`, params,);
};
//根据id查看语料库信息
export const corpusInformation = (params) => {
  return ajaxPostJson(`/record/foreground/getReviseRecordById`, params,);
};
//获取领域
export const getDomain = (params) => {
  return ajaxPostJson(`/common/queryOptionList`, params,);
};
//修改语料库
export const updateCorpus = (params) => {
  return ajaxPostJson(`/record/foreground/updateTransCorpusLib`, params,);
};
//删除句子明细
export const deleteSentenceSubsidiary = (params) => {
  return ajaxPostJson(`/record/foreground/deleteSentDetails`, params,);
};
//语料库修改句子明细
export const sentenceDetailsCorpus = (params) => {
  return ajaxPostJson(`/record/foreground/updateCorpusSent`, params,);
};
//添加固定句子
export const addFixedSentences = (params) => {
  return ajaxPostJson(`/record/foreground/addSent`, params,);
};


/* cat1.6 feature 1.4.3 */
// 入库记录列表接口
export const queryRecordPage = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/record/foreground/queryRecordPage`, params,);
};
// 入库审核记录状态条数统计
export const countRecordsV2 = (params) => {
  return ajaxPostJson(`/record/foreground/countRecordsV2`, params,);
};
// 入库审核记录筛选条件查询
export const queryCriteria = (params) => {
  return ajaxPostJson(`/record/foreground/queryCriteria`, params,);
};
// 取消入库
export const cancel = (params) => {
  return ajaxPostJson(`/record/foreground/cancel`, params,);
};
// 重新入库
export const reWarehousing = (params) => {
  return ajaxPostJson(`/record/foreground/reWarehousing`, params,);
};
// 重新入库
export const deleteRecord = (params) => {
  return ajaxPostJson(`/record/foreground/deleteRecord`, params,);
};
